import { useMutation } from 'react-query'

// Services
import { UpdateDocument } from 'services/api/Ai'

export default () => {
  const {
    mutate: updateDocument,
    data: updateDocumentData,
    error: updateDocumentError,
    isLoading: isUpdateDocumentLoading,
    isSuccess: isUpdateDocumentSuccess,
    isError: isUpdateDocumentError,
  } = useMutation(UpdateDocument)

  return {
    updateDocument,
    updateDocumentData,
    updateDocumentError,
    isUpdateDocumentLoading,
    isUpdateDocumentSuccess,
    isUpdateDocumentError,
  }
}
